$(document).ready(function(){
	// track repair signin 
	if(!document.querySelector('.inquiry-status-area')) return false;

	// repair service Inquiry
	var rcIq = {
		el: $('.inquiry-status-area.field-wrap form'), // form
		//mobileForm: document.getElementById('trackRepairMobile'),
		init: function() {
			rcIq.addEvent();
		},
		beforeSubmit: function(e){
			e.preventDefault();
			$('body').trigger('ajaxLoadBefore');
			var currentForm = e.currentTarget;
			
			/* LGCOMMON-6557 START */
			var useNewCaptcha = $(currentForm).find('#useNewCaptcha').val();
			var useNewCaptchaEmail = $(currentForm).find('#useNewCaptchaEmail').val();
			
			if(!!useNewCaptcha){
				if( $("#useNewCaptcha").length > 0 && $("#useNewCaptcha").val() == "Y" && !!$('#siteKey').val() && $("#useNewCaptchaView").val() == "N"){
					var reCaptcha_Key = $('#siteKey').val();
			    	grecaptcha.enterprise.ready(function() {
			    		grecaptcha.enterprise.execute(reCaptcha_Key, {action: $("#recaptchaPageType").val()}).then(function(token) {
			    			$("#verifyKey").val(btoa(token));
			    			formSubmit();
			    		});
			    	});
				}
			}else if(!!useNewCaptchaEmail){
				if( $("#useNewCaptchaEmail").length > 0 && $("#useNewCaptchaEmail").val() == "Y" && !!$('#siteKeyEmail').val() && $("#useNewCaptchaViewEmail").val() == "N"){
					var reCaptcha_Key = $('#siteKeyEmail').val();
			    	grecaptcha.enterprise.ready(function() {
			    		grecaptcha.enterprise.execute(reCaptcha_Key, {action: $("#recaptchaPageTypeEmail").val()}).then(function(token) {
			    			$("#verifyKeyEmail").val(btoa(token));
			    			formSubmit();
			    		});
			    	});
				}
			}else{
				$('body').trigger('ajaxLoadEnd');
			}
			
			function formSubmit(){
				// ajax validation
				if($(currentForm).checkValidation()) {
					var url = currentForm.getAttribute('data-url');
					var urlParam = currentForm.getAttribute('data-url-param') ? currentForm.getAttribute('data-url-param').split("|")[0] + "=" + currentForm.getAttribute('data-url-param').split("|")[1] : "";
					var param = xssfilter($(currentForm).serialize()+"&"+xssfilter(urlParam));
					var methodType = $(currentForm).data('ajaxMethod');
					console.log(param);
					// number validation
					$('body').trigger('ajaxLoadBefore');
					ajax.call(url, param, 'json', function(data){
						$('body').trigger('ajaxLoadEnd');
						if(!data.result){
							var block = $(currentForm).find('.ajax-msg');
							$(currentForm).find('.field-block').addClass('error');
							if(data.msg) {
								block.text(data.msg);
							}
							block.show().siblings().hide();
							$("#modal_inquiry_status_noresult").modal('show');
							$('body').trigger('ajaxLoadEnd');
						}else {
							if(data.flag && data.flag != null) {
								currentForm.flag.value = data.flag;
							}
							if(data.submitData && data.submitData != null) {
								// currentForm.flag.value = data.flag;
								if(!currentForm.submitData) {
									$(currentForm).append('<input type="hidden" name="submitData" value="">');
								}
								currentForm.submitData.value = JSON.stringify(data.submitData);
							}
							
							if(!!useNewCaptcha){
								var reCaptcha_Key = $('#siteKey').val();
						    	grecaptcha.enterprise.ready(function() {
						    		grecaptcha.enterprise.execute(reCaptcha_Key, {action: $("#recaptchaPageType").val()}).then(function(token) {
						    			$("#verifyKey").val(btoa(token));
						    			$("#verifyKeyExtra").val(data.verifyKeyExtra);
						    			currentForm.submit();
						    			$('body').trigger('ajaxLoadEnd');
						    		});
						    	});
							}else if(!!useNewCaptchaEmail){
								var reCaptcha_Key = $('#siteKeyEmail').val();
						    	grecaptcha.enterprise.ready(function() {
						    		grecaptcha.enterprise.execute(reCaptcha_Key, {action: $("#recaptchaPageTypeEmail").val()}).then(function(token) {
						    			$("#verifyKeyEmail").val(btoa(token));
						    			$("#verifyKeyExtraEmail").val(data.verifyKeyExtraEmail);
						    			currentForm.submit();
						    			$('body').trigger('ajaxLoadEnd');
						    		});
						    	});
							}else{
								$('body').trigger('ajaxLoadEnd');
							}
						}
					}, methodType);
				}
			}
			/* LGCOMMON-6557 END */
		},
		addEvent: function(){
			rcIq.el.each(function(){
				$(this).on({
					submit: rcIq.beforeSubmit
				});
			});
			
			// $(rcIq.mobileForm).on({
			// 	submit: rcIq.beforeSubmit
			// });
		}
	};

	rcIq.init();
});